import styled from "../../styles/styled-components";
import { mediaQueries } from "../../styles/media-queries";
import { H2, H1 } from "../../styles/global";

const HomeStyle = styled.div`
	.points-confirm {
		.label {
			text-transform: none;
			color: #000;
			text-align: left;
			padding-top: 0px;
    		padding-bottom: 0px;
		}

		.result {
			text-align: right;

			&.confirmed {
				color : green;
			}

			&.unconfirmed {
				color: red;
			}
		}


	}

	.login {
		margin: 20px auto;
		padding: 40px 20px;
		background: #151820;
		color: #FFF;

		h2 {
			font-size: 36px;
			color: ${props => props.theme.primaryColor};
		}
	}

	.onboarding {
		padding: 0px;
		background: #FFF;

		min-height: 250px;

		h4 {
			color: ${props => props.theme.primaryContrast} !important;
		}
		img {
			max-height: 200px;
		}
	}

	
`;

const LandingStyle = styled.div`

	background-image: url('/assets/img/BackGround.png');
	color: #FFF;
	font-size: 1.2em;

	.points-confirm {
		.label {
			text-transform: none;
			color: #000;
			text-align: left;
			padding-top: 0px;
			padding-bottom: 0px;
		}

		.result {
			text-align: right;

			&.confirmed {
				color: green;
			}

			&.unconfirmed {
				color: red;
			}
		}
	}

	.login {
		margin: 20px auto;
		padding: 40px 20px;
		background: #151820;
		color: #FFF;

		h2 {
			font-size: 36px;
			color: ${props => props.theme.primaryColor};
		}
	}

	.onboarding {
		padding: 20px 0;
		min-height: 250px;

		.title {
			color: ${props => props.theme.primaryColor};
		}

		h4 {
			color: ${props => props.theme.primaryColor} !important;
		}
		img {
			padding-bottom: 10px;
		}
	}

`;

export {
	HomeStyle,
	LandingStyle
};